var map = {
	"./de/mecha-btn.png": "Z54o",
	"./en/mecha-btn.png": "CQfR",
	"./es/mecha-btn.png": "jfRK",
	"./fr/mecha-btn.png": "UVY6",
	"./ja/mecha-btn.png": "uJh0",
	"./ko/mecha-btn.png": "MPaN",
	"./pt/mecha-btn.png": "MXbp",
	"./ru/mecha-btn.png": "z94r",
	"./tc/mecha-btn.png": "eS0D",
	"./th/mecha-btn.png": "Iq+7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8DUj";